export class CompanyList {
    constructor(companyList) {
      this.companies = []; // Initialize an empty array to hold company objects
        console.log('Constructor',companyList);
      companyList.forEach(company => {
        this.companies.push({ name: company.name, companyId: company.companyId ,status:company.status});
      });
    }
  }